"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMUNITY_CARD_MANIFEST = exports.MISINFORMATION_CARDS = void 0;
const CardName_1 = require("../../CardName");
const GameModule_1 = require("../../GameModule");
const CardManifest_1 = require("../CardManifest");
const AgricolaInc_1 = require("./corporations/AgricolaInc");
const CuriosityII_1 = require("./corporations/CuriosityII");
const Incite_1 = require("./corporations/Incite");
const Playwrights_1 = require("./corporations/Playwrights");
const ProjectWorkshop_1 = require("./corporations/ProjectWorkshop");
const ResearchGrant_1 = require("./preludes/ResearchGrant");
const ValuableGases_1 = require("./preludes/ValuableGases");
const VenusFirst_1 = require("./preludes/VenusFirst");
const AerospaceMission_1 = require("./preludes/AerospaceMission");
const TradeAdvance_1 = require("./preludes/TradeAdvance");
const PoliticalUprising_1 = require("./preludes/PoliticalUprising");
const ByElection_1 = require("./preludes/ByElection");
const Midas_1 = require("./corporations/Midas");
const ColonialOne_1 = require("./corporations/ColonialOne");
const Hotsprings_1 = require("./corporations/Hotsprings");
const JunkVentures_1 = require("./corporations/JunkVentures");
const Aristarchus_1 = require("./corporations/Aristarchus");
const HydrogenBombardment_1 = require("./preludes/HydrogenBombardment");
const VitalColony_1 = require("./preludes/VitalColony");
const NitrateReducers_1 = require("./preludes/NitrateReducers");
const ExperiencedMartians_1 = require("./preludes/ExperiencedMartians");
const TradeInfrastructure_1 = require("./preludes/TradeInfrastructure");
const GeothermalVent_1 = require("./preludes/GeothermalVent");
const AccumulatedKnowledge_1 = require("./preludes/AccumulatedKnowledge");
const BotanicalHarvest_1 = require("./preludes/BotanicalHarvest");
const MartianLumberYard_1 = require("./preludes/MartianLumberYard");
const FortifiedOutpost_1 = require("./preludes/FortifiedOutpost");
const GamblingHouse_1 = require("./preludes/GamblingHouse");
const LabourUnion_1 = require("./corporations/LabourUnion");
const UnitedNationsMissionOne_1 = require("./corporations/UnitedNationsMissionOne");
const AbandonedSteelForge_1 = require("./preludes/AbandonedSteelForge");
const PerseveranceLanding_1 = require("./PerseveranceLanding");
const MarsCoalition_1 = require("./corporations/MarsCoalition");
const LaserFactory_1 = require("./preludes/LaserFactory");
const SolarBatteries_1 = require("./preludes/SolarBatteries");
const TharsisPrototypeCity_1 = require("./preludes/TharsisPrototypeCity");
const GroundwaterMohole_1 = require("./preludes/GroundwaterMohole");
const NewMarsResearchFacility_1 = require("./preludes/NewMarsResearchFacility");
const TerrainAcquisition_1 = require("./preludes/TerrainAcquisition");
const Microalgae_1 = require("./preludes/Microalgae");
const MiningImprovements_1 = require("./preludes/MiningImprovements");
const TerraformingMission_1 = require("./preludes/TerraformingMission");
const WildlifeSponsors_1 = require("./preludes/WildlifeSponsors");
const TempestInc_1 = require("./corporations/TempestInc");
const ExecutiveOrder_1 = require("./preludes/ExecutiveOrder");
const EcologyLake_1 = require("./preludes/EcologyLake");
const Stakeholders_1 = require("./preludes/Stakeholders");
const Spaceways_1 = require("./corporations/Spaceways");
const MaraboutShiritori_1 = require("./corporations/MaraboutShiritori");
const EnergyBeam_1 = require("./preludes/EnergyBeam");
const CommitteeRepresentative_1 = require("./preludes/CommitteeRepresentative");
const SecretSantaSociety_1 = require("./corporations/SecretSantaSociety");
const CoLeadership_1 = require("./preludes/CoLeadership");
const Bentenmaru_1 = require("./corporations/Bentenmaru");
const Aerotech_1 = require("./corporations/Aerotech");
const FauxNews_1 = require("./corporations/FauxNews");
const Misinformation1_1 = require("./misinformation/Misinformation1");
const Misinformation2_1 = require("./misinformation/Misinformation2");
const Misinformation3_1 = require("./misinformation/Misinformation3");
const Misinformation4_1 = require("./misinformation/Misinformation4");
const Misinformation5_1 = require("./misinformation/Misinformation5");
const Misinformation6_1 = require("./misinformation/Misinformation6");
const Misinformation7_1 = require("./misinformation/Misinformation7");
const Misinformation8_1 = require("./misinformation/Misinformation8");
const Misinformation9_1 = require("./misinformation/Misinformation9");
const Misinformation10_1 = require("./misinformation/Misinformation10");
const Misinformation11_1 = require("./misinformation/Misinformation11");
const Misinformation12_1 = require("./misinformation/Misinformation12");
const Misinformation13_1 = require("./misinformation/Misinformation13");
const Misinformation14_1 = require("./misinformation/Misinformation14");
const Misinformation15_1 = require("./misinformation/Misinformation15");
const Misinformation16_1 = require("./misinformation/Misinformation16");
const Misinformation17_1 = require("./misinformation/Misinformation17");
const Misinformation18_1 = require("./misinformation/Misinformation18");
const Misinformation19_1 = require("./misinformation/Misinformation19");
const Misinformation20_1 = require("./misinformation/Misinformation20");
const Misinformation21_1 = require("./misinformation/Misinformation21");
const Misinformation22_1 = require("./misinformation/Misinformation22");
const Misinformation23_1 = require("./misinformation/Misinformation23");
const Misinformation24_1 = require("./misinformation/Misinformation24");
const Misinformation25_1 = require("./misinformation/Misinformation25");
const Misinformation26_1 = require("./misinformation/Misinformation26");
const Misinformation27_1 = require("./misinformation/Misinformation27");
const Misinformation28_1 = require("./misinformation/Misinformation28");
const Misinformation29_1 = require("./misinformation/Misinformation29");
const Misinformation30_1 = require("./misinformation/Misinformation30");
const Misinformation31_1 = require("./misinformation/Misinformation31");
const Misinformation32_1 = require("./misinformation/Misinformation32");
const Misinformation33_1 = require("./misinformation/Misinformation33");
const Misinformation34_1 = require("./misinformation/Misinformation34");
const Misinformation35_1 = require("./misinformation/Misinformation35");
const Misinformation36_1 = require("./misinformation/Misinformation36");
const Misinformation37_1 = require("./misinformation/Misinformation37");
const Misinformation38_1 = require("./misinformation/Misinformation38");
const Misinformation39_1 = require("./misinformation/Misinformation39");
const Misinformation40_1 = require("./misinformation/Misinformation40");
const Misinformation41_1 = require("./misinformation/Misinformation41");
const Misinformation42_1 = require("./misinformation/Misinformation42");
const Misinformation43_1 = require("./misinformation/Misinformation43");
const Misinformation44_1 = require("./misinformation/Misinformation44");
const Misinformation45_1 = require("./misinformation/Misinformation45");
const Misinformation46_1 = require("./misinformation/Misinformation46");
const Misinformation47_1 = require("./misinformation/Misinformation47");
const Misinformation48_1 = require("./misinformation/Misinformation48");
const Misinformation49_1 = require("./misinformation/Misinformation49");
const Misinformation50_1 = require("./misinformation/Misinformation50");
const Misinformation51_1 = require("./misinformation/Misinformation51");
const Misinformation52_1 = require("./misinformation/Misinformation52");
const Misinformation53_1 = require("./misinformation/Misinformation53");
const Misinformation54_1 = require("./misinformation/Misinformation54");
const Misinformation55_1 = require("./misinformation/Misinformation55");
const Misinformation56_1 = require("./misinformation/Misinformation56");
const Misinformation57_1 = require("./misinformation/Misinformation57");
const Misinformation58_1 = require("./misinformation/Misinformation58");
const Misinformation59_1 = require("./misinformation/Misinformation59");
const Misinformation60_1 = require("./misinformation/Misinformation60");
const HeatFirstInitiative_1 = require("./preludes/HeatFirstInitiative");
const MartianRepublic_1 = require("./preludes/MartianRepublic");
const PreservationistCampaign_1 = require("./preludes/PreservationistCampaign");
const CorporateAlliance_1 = require("./preludes/CorporateAlliance");
const GreenMarsInitiative_1 = require("./preludes/GreenMarsInitiative");
const IntellectualistMovement_1 = require("./preludes/IntellectualistMovement");
const CyanobacteriaPods_1 = require("./preludes/CyanobacteriaPods");
const AlliedResearch_1 = require("./preludes/AlliedResearch");
exports.MISINFORMATION_CARDS = [
    CardName_1.CardName.MISINFORMATION_1,
    CardName_1.CardName.MISINFORMATION_2,
    CardName_1.CardName.MISINFORMATION_3,
    CardName_1.CardName.MISINFORMATION_4,
    CardName_1.CardName.MISINFORMATION_5,
    CardName_1.CardName.MISINFORMATION_6,
    CardName_1.CardName.MISINFORMATION_7,
    CardName_1.CardName.MISINFORMATION_8,
    CardName_1.CardName.MISINFORMATION_9,
    CardName_1.CardName.MISINFORMATION_10,
    CardName_1.CardName.MISINFORMATION_11,
    CardName_1.CardName.MISINFORMATION_12,
    CardName_1.CardName.MISINFORMATION_13,
    CardName_1.CardName.MISINFORMATION_14,
    CardName_1.CardName.MISINFORMATION_15,
    CardName_1.CardName.MISINFORMATION_16,
    CardName_1.CardName.MISINFORMATION_17,
    CardName_1.CardName.MISINFORMATION_18,
    CardName_1.CardName.MISINFORMATION_19,
    CardName_1.CardName.MISINFORMATION_20,
    CardName_1.CardName.MISINFORMATION_21,
    CardName_1.CardName.MISINFORMATION_22,
    CardName_1.CardName.MISINFORMATION_23,
    CardName_1.CardName.MISINFORMATION_24,
    CardName_1.CardName.MISINFORMATION_25,
    CardName_1.CardName.MISINFORMATION_26,
    CardName_1.CardName.MISINFORMATION_27,
    CardName_1.CardName.MISINFORMATION_28,
    CardName_1.CardName.MISINFORMATION_29,
    CardName_1.CardName.MISINFORMATION_30,
    CardName_1.CardName.MISINFORMATION_31,
    CardName_1.CardName.MISINFORMATION_32,
    CardName_1.CardName.MISINFORMATION_33,
    CardName_1.CardName.MISINFORMATION_34,
    CardName_1.CardName.MISINFORMATION_35,
    CardName_1.CardName.MISINFORMATION_36,
    CardName_1.CardName.MISINFORMATION_37,
    CardName_1.CardName.MISINFORMATION_38,
    CardName_1.CardName.MISINFORMATION_39,
    CardName_1.CardName.MISINFORMATION_40,
    CardName_1.CardName.MISINFORMATION_41,
    CardName_1.CardName.MISINFORMATION_42,
    CardName_1.CardName.MISINFORMATION_43,
    CardName_1.CardName.MISINFORMATION_44,
    CardName_1.CardName.MISINFORMATION_45,
    CardName_1.CardName.MISINFORMATION_46,
    CardName_1.CardName.MISINFORMATION_47,
    CardName_1.CardName.MISINFORMATION_48,
    CardName_1.CardName.MISINFORMATION_49,
    CardName_1.CardName.MISINFORMATION_50,
    CardName_1.CardName.MISINFORMATION_51,
    CardName_1.CardName.MISINFORMATION_52,
    CardName_1.CardName.MISINFORMATION_53,
    CardName_1.CardName.MISINFORMATION_54,
    CardName_1.CardName.MISINFORMATION_55,
    CardName_1.CardName.MISINFORMATION_56,
    CardName_1.CardName.MISINFORMATION_57,
    CardName_1.CardName.MISINFORMATION_58,
    CardName_1.CardName.MISINFORMATION_59,
    CardName_1.CardName.MISINFORMATION_60,
];
exports.COMMUNITY_CARD_MANIFEST = new CardManifest_1.CardManifest({
    module: GameModule_1.GameModule.Community,
    projectCards: [
        { cardName: CardName_1.CardName.PERSEVERANCE_LANDING, Factory: PerseveranceLanding_1.PerseveranceLanding },
        { cardName: CardName_1.CardName.MISINFORMATION_1, Factory: Misinformation1_1.Misinformation1 },
        { cardName: CardName_1.CardName.MISINFORMATION_2, Factory: Misinformation2_1.Misinformation2 },
        { cardName: CardName_1.CardName.MISINFORMATION_3, Factory: Misinformation3_1.Misinformation3 },
        { cardName: CardName_1.CardName.MISINFORMATION_4, Factory: Misinformation4_1.Misinformation4 },
        { cardName: CardName_1.CardName.MISINFORMATION_5, Factory: Misinformation5_1.Misinformation5 },
        { cardName: CardName_1.CardName.MISINFORMATION_6, Factory: Misinformation6_1.Misinformation6 },
        { cardName: CardName_1.CardName.MISINFORMATION_7, Factory: Misinformation7_1.Misinformation7 },
        { cardName: CardName_1.CardName.MISINFORMATION_8, Factory: Misinformation8_1.Misinformation8 },
        { cardName: CardName_1.CardName.MISINFORMATION_9, Factory: Misinformation9_1.Misinformation9 },
        { cardName: CardName_1.CardName.MISINFORMATION_10, Factory: Misinformation10_1.Misinformation10 },
        { cardName: CardName_1.CardName.MISINFORMATION_11, Factory: Misinformation11_1.Misinformation11 },
        { cardName: CardName_1.CardName.MISINFORMATION_12, Factory: Misinformation12_1.Misinformation12 },
        { cardName: CardName_1.CardName.MISINFORMATION_13, Factory: Misinformation13_1.Misinformation13 },
        { cardName: CardName_1.CardName.MISINFORMATION_14, Factory: Misinformation14_1.Misinformation14 },
        { cardName: CardName_1.CardName.MISINFORMATION_15, Factory: Misinformation15_1.Misinformation15 },
        { cardName: CardName_1.CardName.MISINFORMATION_16, Factory: Misinformation16_1.Misinformation16 },
        { cardName: CardName_1.CardName.MISINFORMATION_17, Factory: Misinformation17_1.Misinformation17 },
        { cardName: CardName_1.CardName.MISINFORMATION_18, Factory: Misinformation18_1.Misinformation18 },
        { cardName: CardName_1.CardName.MISINFORMATION_19, Factory: Misinformation19_1.Misinformation19 },
        { cardName: CardName_1.CardName.MISINFORMATION_20, Factory: Misinformation20_1.Misinformation20 },
        { cardName: CardName_1.CardName.MISINFORMATION_21, Factory: Misinformation21_1.Misinformation21 },
        { cardName: CardName_1.CardName.MISINFORMATION_22, Factory: Misinformation22_1.Misinformation22 },
        { cardName: CardName_1.CardName.MISINFORMATION_23, Factory: Misinformation23_1.Misinformation23 },
        { cardName: CardName_1.CardName.MISINFORMATION_24, Factory: Misinformation24_1.Misinformation24 },
        { cardName: CardName_1.CardName.MISINFORMATION_25, Factory: Misinformation25_1.Misinformation25 },
        { cardName: CardName_1.CardName.MISINFORMATION_26, Factory: Misinformation26_1.Misinformation26 },
        { cardName: CardName_1.CardName.MISINFORMATION_27, Factory: Misinformation27_1.Misinformation27 },
        { cardName: CardName_1.CardName.MISINFORMATION_28, Factory: Misinformation28_1.Misinformation28 },
        { cardName: CardName_1.CardName.MISINFORMATION_29, Factory: Misinformation29_1.Misinformation29 },
        { cardName: CardName_1.CardName.MISINFORMATION_30, Factory: Misinformation30_1.Misinformation30 },
        { cardName: CardName_1.CardName.MISINFORMATION_31, Factory: Misinformation31_1.Misinformation31 },
        { cardName: CardName_1.CardName.MISINFORMATION_32, Factory: Misinformation32_1.Misinformation32 },
        { cardName: CardName_1.CardName.MISINFORMATION_33, Factory: Misinformation33_1.Misinformation33 },
        { cardName: CardName_1.CardName.MISINFORMATION_34, Factory: Misinformation34_1.Misinformation34 },
        { cardName: CardName_1.CardName.MISINFORMATION_35, Factory: Misinformation35_1.Misinformation35 },
        { cardName: CardName_1.CardName.MISINFORMATION_36, Factory: Misinformation36_1.Misinformation36 },
        { cardName: CardName_1.CardName.MISINFORMATION_37, Factory: Misinformation37_1.Misinformation37 },
        { cardName: CardName_1.CardName.MISINFORMATION_38, Factory: Misinformation38_1.Misinformation38 },
        { cardName: CardName_1.CardName.MISINFORMATION_39, Factory: Misinformation39_1.Misinformation39 },
        { cardName: CardName_1.CardName.MISINFORMATION_40, Factory: Misinformation40_1.Misinformation40 },
        { cardName: CardName_1.CardName.MISINFORMATION_41, Factory: Misinformation41_1.Misinformation41 },
        { cardName: CardName_1.CardName.MISINFORMATION_42, Factory: Misinformation42_1.Misinformation42 },
        { cardName: CardName_1.CardName.MISINFORMATION_43, Factory: Misinformation43_1.Misinformation43 },
        { cardName: CardName_1.CardName.MISINFORMATION_44, Factory: Misinformation44_1.Misinformation44 },
        { cardName: CardName_1.CardName.MISINFORMATION_45, Factory: Misinformation45_1.Misinformation45 },
        { cardName: CardName_1.CardName.MISINFORMATION_46, Factory: Misinformation46_1.Misinformation46 },
        { cardName: CardName_1.CardName.MISINFORMATION_47, Factory: Misinformation47_1.Misinformation47 },
        { cardName: CardName_1.CardName.MISINFORMATION_48, Factory: Misinformation48_1.Misinformation48 },
        { cardName: CardName_1.CardName.MISINFORMATION_49, Factory: Misinformation49_1.Misinformation49 },
        { cardName: CardName_1.CardName.MISINFORMATION_50, Factory: Misinformation50_1.Misinformation50 },
        { cardName: CardName_1.CardName.MISINFORMATION_51, Factory: Misinformation51_1.Misinformation51 },
        { cardName: CardName_1.CardName.MISINFORMATION_52, Factory: Misinformation52_1.Misinformation52 },
        { cardName: CardName_1.CardName.MISINFORMATION_53, Factory: Misinformation53_1.Misinformation53 },
        { cardName: CardName_1.CardName.MISINFORMATION_54, Factory: Misinformation54_1.Misinformation54 },
        { cardName: CardName_1.CardName.MISINFORMATION_55, Factory: Misinformation55_1.Misinformation55 },
        { cardName: CardName_1.CardName.MISINFORMATION_56, Factory: Misinformation56_1.Misinformation56 },
        { cardName: CardName_1.CardName.MISINFORMATION_57, Factory: Misinformation57_1.Misinformation57 },
        { cardName: CardName_1.CardName.MISINFORMATION_58, Factory: Misinformation58_1.Misinformation58 },
        { cardName: CardName_1.CardName.MISINFORMATION_59, Factory: Misinformation59_1.Misinformation59 },
        { cardName: CardName_1.CardName.MISINFORMATION_60, Factory: Misinformation60_1.Misinformation60 },
    ],
    corporationCards: [
        { cardName: CardName_1.CardName.AGRICOLA_INC, Factory: AgricolaInc_1.AgricolaInc },
        { cardName: CardName_1.CardName.PROJECT_WORKSHOP, Factory: ProjectWorkshop_1.ProjectWorkshop },
        { cardName: CardName_1.CardName.INCITE, Factory: Incite_1.Incite, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.PLAYWRIGHTS, Factory: Playwrights_1.Playwrights },
        { cardName: CardName_1.CardName.CURIOSITY_II, Factory: CuriosityII_1.CuriosityII },
        { cardName: CardName_1.CardName.MIDAS, Factory: Midas_1.Midas },
        { cardName: CardName_1.CardName.COLONIAL_ONE, Factory: ColonialOne_1.ColonialOne, compatibility: GameModule_1.GameModule.Colonies },
        { cardName: CardName_1.CardName.HOTSPRINGS, Factory: Hotsprings_1.Hotsprings },
        { cardName: CardName_1.CardName.JUNK_VENTURES, Factory: JunkVentures_1.JunkVentures },
        { cardName: CardName_1.CardName.ARISTARCHUS, Factory: Aristarchus_1.Aristarchus },
        { cardName: CardName_1.CardName.LABOUR_UNION, Factory: LabourUnion_1.LabourUnion },
        { cardName: CardName_1.CardName.UNITED_NATIONS_MISSION_ONE, Factory: UnitedNationsMissionOne_1.UnitedNationsMissionOne },
        { cardName: CardName_1.CardName.MARS_COALITION, Factory: MarsCoalition_1.MarsCoalition, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.TEMPEST_INC, Factory: TempestInc_1.TempestInc },
        { cardName: CardName_1.CardName.SPACEWAYS, Factory: Spaceways_1.Spaceways },
        { cardName: CardName_1.CardName.MARABOUT_SHIRITORI, Factory: MaraboutShiritori_1.MaraboutShiritori },
        { cardName: CardName_1.CardName.SECRET_SANTA_SOCIETY, Factory: SecretSantaSociety_1.SecretSantaSociety },
        { cardName: CardName_1.CardName.BENTENMARU, Factory: Bentenmaru_1.Bentenmaru },
        { cardName: CardName_1.CardName.AEROTECH, Factory: Aerotech_1.Aerotech },
        { cardName: CardName_1.CardName.FAUX_NEWS, Factory: FauxNews_1.FauxNews },
    ],
    preludeCards: [
        { cardName: CardName_1.CardName.RESEARCH_GRANT, Factory: ResearchGrant_1.ResearchGrant },
        {
            cardName: CardName_1.CardName.VALUABLE_GASES,
            Factory: ValuableGases_1.ValuableGases,
            compatibility: GameModule_1.GameModule.Venus,
        },
        {
            cardName: CardName_1.CardName.VENUS_FIRST,
            Factory: VenusFirst_1.VenusFirst,
            compatibility: GameModule_1.GameModule.Venus,
        },
        {
            cardName: CardName_1.CardName.AEROSPACE_MISSION,
            Factory: AerospaceMission_1.AerospaceMission,
            compatibility: GameModule_1.GameModule.Colonies,
        },
        {
            cardName: CardName_1.CardName.TRADE_ADVANCE,
            Factory: TradeAdvance_1.TradeAdvance,
            compatibility: GameModule_1.GameModule.Colonies,
        },
        {
            cardName: CardName_1.CardName.POLITICAL_UPRISING,
            Factory: PoliticalUprising_1.PoliticalUprising,
            compatibility: GameModule_1.GameModule.Turmoil,
        },
        {
            cardName: CardName_1.CardName.BY_ELECTION,
            Factory: ByElection_1.ByElection,
            compatibility: GameModule_1.GameModule.Turmoil,
        },
        {
            cardName: CardName_1.CardName.HYDROGEN_BOMBARDMENT,
            Factory: HydrogenBombardment_1.HydrogenBombardment,
            compatibility: GameModule_1.GameModule.Venus,
        },
        {
            cardName: CardName_1.CardName.VITAL_COLONY,
            Factory: VitalColony_1.VitalColony,
            compatibility: GameModule_1.GameModule.Colonies,
        },
        {
            cardName: CardName_1.CardName.NITRATE_REDUCERS,
            Factory: NitrateReducers_1.NitrateReducers,
            compatibility: GameModule_1.GameModule.Venus,
        },
        {
            cardName: CardName_1.CardName.EXPERIENCED_MARTIANS,
            Factory: ExperiencedMartians_1.ExperiencedMartians,
            compatibility: GameModule_1.GameModule.Turmoil,
        },
        {
            cardName: CardName_1.CardName.TRADE_INFRASTRUCTURE,
            Factory: TradeInfrastructure_1.TradeInfrastructure,
            compatibility: GameModule_1.GameModule.Colonies,
        },
        { cardName: CardName_1.CardName.GEOTHERMAL_VENT, Factory: GeothermalVent_1.GeothermalVent },
        { cardName: CardName_1.CardName.ACCUMULATED_KNOWLEDGE, Factory: AccumulatedKnowledge_1.AccumulatedKnowledge },
        { cardName: CardName_1.CardName.BOTANICAL_HARVEST, Factory: BotanicalHarvest_1.BotanicalHarvest },
        { cardName: CardName_1.CardName.MARTIAN_LUMBER_YARD, Factory: MartianLumberYard_1.MartianLumberYard },
        { cardName: CardName_1.CardName.FORTIFIED_OUTPOST, Factory: FortifiedOutpost_1.FortifiedOutpost },
        { cardName: CardName_1.CardName.GAMBLING_HOUSE, Factory: GamblingHouse_1.GamblingHouse },
        { cardName: CardName_1.CardName.ABANDONED_STEEL_FORGE, Factory: AbandonedSteelForge_1.AbandonedSteelForge },
        { cardName: CardName_1.CardName.LASER_FACTORY, Factory: LaserFactory_1.LaserFactory },
        { cardName: CardName_1.CardName.SOLAR_BATTERIES, Factory: SolarBatteries_1.SolarBatteries },
        { cardName: CardName_1.CardName.THARSIS_PROTOTYPE_CITY, Factory: TharsisPrototypeCity_1.TharsisPrototypeCity },
        { cardName: CardName_1.CardName.GROUNDWATER_MOHOLE, Factory: GroundwaterMohole_1.GroundwaterMohole },
        { cardName: CardName_1.CardName.NEW_MARS_RESEARCH_FACILITY, Factory: NewMarsResearchFacility_1.NewMarsResearchFacility },
        { cardName: CardName_1.CardName.TERRAIN_ACQUISITION, Factory: TerrainAcquisition_1.TerrainAcquisition },
        { cardName: CardName_1.CardName.MICROALGAE, Factory: Microalgae_1.Microalgae },
        { cardName: CardName_1.CardName.MINING_IMPROVEMENTS, Factory: MiningImprovements_1.MiningImprovements },
        { cardName: CardName_1.CardName.TERRAFORMING_MISSION, Factory: TerraformingMission_1.TerraformingMission },
        { cardName: CardName_1.CardName.WILDLIFE_SPONSORS, Factory: WildlifeSponsors_1.WildlifeSponsors },
        { cardName: CardName_1.CardName.EXECUTIVE_ORDER, Factory: ExecutiveOrder_1.ExecutiveOrder, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.ECOLOGY_LAKE, Factory: EcologyLake_1.EcologyLake },
        { cardName: CardName_1.CardName.STAKEHOLDERS, Factory: Stakeholders_1.Stakeholders },
        { cardName: CardName_1.CardName.ENERGY_BEAM, Factory: EnergyBeam_1.EnergyBeam },
        { cardName: CardName_1.CardName.COMMITTEE_REPRESENTATIVE, Factory: CommitteeRepresentative_1.CommitteeRepresentative, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.CO_LEADERSHIP, Factory: CoLeadership_1.CoLeadership, compatibility: GameModule_1.GameModule.Leader },
        { cardName: CardName_1.CardName.HEAT_FIRST_INITIATIVE, Factory: HeatFirstInitiative_1.HeatFirstInitiative, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.MARTIAN_REPUBLIC, Factory: MartianRepublic_1.MartianRepublic, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.PRESERVATIONIST_CAMPAIGN, Factory: PreservationistCampaign_1.PreservationistCampaign, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.CORPORATE_ALLIANCE, Factory: CorporateAlliance_1.CorporateAlliance, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.GREEN_MARS_INITIATIVE, Factory: GreenMarsInitiative_1.GreenMarsInitiative, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.INTELLECTUALIST_MOVEMENT, Factory: IntellectualistMovement_1.IntellectualistMovement, compatibility: GameModule_1.GameModule.Turmoil },
        { cardName: CardName_1.CardName.CYANOBACTERIA_PODS, Factory: CyanobacteriaPods_1.CyanobacteriaPods },
        { cardName: CardName_1.CardName.ALLIED_RESEARCH, Factory: AlliedResearch_1.AlliedResearch },
    ],
    cardsToRemove: [
        ...exports.MISINFORMATION_CARDS,
    ],
});
//# sourceMappingURL=CommunityCardManifest.js.map